import React from "react";

export default function Math_LinearFunctions() {
  return (
    <div>
      <h1>Math_LinearFunctions</h1>
      <p>This is the Math_LinearFunctions component.</p>
    </div>
  );
}
